import React from "react";
import { IMenuItem } from "../../@types/types";
import FeatherIcon from "feather-icons-react";
import { addActiveClassname } from "../../utils";
import NavItems from "./NavItems";

interface AdditionalLinksProps {
  links: IMenuItem[];
  selectedId: string;
  toggleMenu: (id: string) => void;
  isOnly?: boolean;
}

const id = "additional_links";

const AdditionalLinks: React.FC<AdditionalLinksProps> = ({
  links,
  selectedId,
  toggleMenu,
  isOnly,
}) => {
  const isActive = selectedId === id;
  return (
    <li
      className={
        isOnly
          ? addActiveClassname("nav-item inner-nav", isActive, "active-inner")
          : addActiveClassname(
              "nav-item inner-nav top",
              isActive,
              "active-inner"
            )
      }
    >
      <span
        onClick={() => {
          toggleMenu(id);
        }}
        className='nav-text-inner'
      >
        Additional Links
      </span>
      <>
        {selectedId && selectedId === id ? (
          <FeatherIcon
            icon='chevron-down'
            className='drop-down'
            onClick={() => toggleMenu(id)}
          />
        ) : (
          <FeatherIcon
            icon='chevron-right'
            className='drop-down'
            onClick={() => toggleMenu(id)}
          />
        )}
      </>
      {links.length && selectedId === id ? <NavItems items={links} /> : null}
    </li>
  );
};

export default AdditionalLinks;
